import { Component, OnInit } from '@angular/core';
import {HttpClient,HttpHeaders,HttpParams} from '@angular/common/http';
import { Report } from 'notiflix/build/notiflix-report-aio';

@Component({
  selector: 'app-quotation-request',
  templateUrl: './quotation-request.component.html',
  styleUrls: ['./quotation-request.component.scss']
})
export class QuotationRequestComponent implements OnInit {
  name:any;
  email:any;
  message:any;
  phone:any;
  website:any;
  company:any;
  service:string="";
  constructor(private http : HttpClient) { }

  ngOnInit() {
  }

  onSubmit() {
    if(this.name==null  || this.name==""){
      Report.failure(
        'Name Missing',
        'Please fill Name in order to submit request !',
        'Okay',
        );
    }
    else if(this.phone==null || this.phone==""){
      Report.failure(
        'Phone Missing',
        'Please fill Phone in order to submit request !',
        'Okay',
        );
    }
    else if(this.email==null || this.email==""){
      Report.failure(
        'Email Missing',
        'Please fill Email in order to submit request !',
        'Okay',
        );
    }
    else if(this.company==null || this.company==""){
      Report.failure(
        'Company Missing',
        'Please fill Company in order to submit request !',
        'Okay',
        );
    }
    else if(this.service==null || this.service==""){
      Report.failure(
        'Service Missing',
        'Please select Service in order to submit request !',
        'Okay',
        );
    }
    else if(this.message==null || this.message==""){
      Report.failure(
        'Message Missing',
        'Please fill Message in order to submit request !',
        'Okay',
        );
    }else{
      const myheader = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
      let body = new HttpParams();
      body = body.set('Name', this.name);
      body = body.set('Phone', this.phone);
      body = body.set('Email', this.email);
      

      
      body = body.set('Company', this.company);
      body = body.set('Website', this.website);
      body = body.set('Service', this.service);
      body = body.set('Message', this.message);
     
      body = body.set('Page', 'Request Quotation Page');
        this.http.post("https://admin.osit.com.sa/api/contactus", body).subscribe((data) => {
        
          Report.success(
            'Request Sent',
            'Your request is successfully sent to concerned department, we will contact you soon !',
            'Okay',
            );
            this.name="";
            this.email="";
            this.message="";
            this.phone="";
            this.website="";
            this.company="";
            this.service="";
        });
     
    }
    
      }

}
